
const moduleName = 'WebComponentSDK';
//const fileName = 'https://myop-statics.s3.ap-southeast-2.amazonaws.com/sdk/0.3.32/_WebComponentSDK.js';

let basePath;
if(window.__federation__.__public_path__){
    basePath = window.__federation__.__public_path__;
}else if(window.__federation__.__use_public_auto_path__){
    basePath = window.__federation__.__public_auto_path__;
}else{
    basePath = 'https://cdn.myop.dev/sdk/next'
}

const fileName = basePath + '/_WebComponentSDK.js';
//console.log(fileName);

export const get = () => {
     return new Promise((resolve,reject)=>{
            window['__federation__']['load__federation__'](fileName, moduleName,resolve);
            
            setTimeout(()=>{
                reject('__federation__ timeout')
            }, window.__federation__.__loading_timeout__);
        })
}